/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface G47CommandOverrideActionArgs {
  /** [s] */
  timeoutS: number;
  /** Keep dock open in OPEN_RELEASE state after takeoff? */
  keepOpen: boolean;
  /**
   * Send a landing pad track request to make the scene mode SCENE_DOCK_DETECT. Wait until the
   * camera mode switch is complete and the camera mode scene is SCENE_DOCK_DETECT
   */
  setDockDetectCameraMode: boolean;
}

export interface G47CommandOverrideResultData {
}

export interface G47CommandOverrideActionStateData {
}

function createBaseG47CommandOverrideActionArgs(): G47CommandOverrideActionArgs {
  return { timeoutS: 0, keepOpen: false, setDockDetectCameraMode: false };
}

export const G47CommandOverrideActionArgs = {
  encode(message: G47CommandOverrideActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeoutS !== 0) {
      writer.uint32(13).float(message.timeoutS);
    }
    if (message.keepOpen === true) {
      writer.uint32(16).bool(message.keepOpen);
    }
    if (message.setDockDetectCameraMode === true) {
      writer.uint32(24).bool(message.setDockDetectCameraMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): G47CommandOverrideActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseG47CommandOverrideActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.keepOpen = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.setDockDetectCameraMode = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): G47CommandOverrideActionArgs {
    return {
      timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0,
      keepOpen: isSet(object.keepOpen) ? globalThis.Boolean(object.keepOpen) : false,
      setDockDetectCameraMode: isSet(object.setDockDetectCameraMode)
        ? globalThis.Boolean(object.setDockDetectCameraMode)
        : false,
    };
  },

  toJSON(message: G47CommandOverrideActionArgs): unknown {
    const obj: any = {};
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    if (message.keepOpen === true) {
      obj.keepOpen = message.keepOpen;
    }
    if (message.setDockDetectCameraMode === true) {
      obj.setDockDetectCameraMode = message.setDockDetectCameraMode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<G47CommandOverrideActionArgs>, I>>(base?: I): G47CommandOverrideActionArgs {
    return G47CommandOverrideActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<G47CommandOverrideActionArgs>, I>>(object: I): G47CommandOverrideActionArgs {
    const message = createBaseG47CommandOverrideActionArgs();
    message.timeoutS = object.timeoutS ?? 0;
    message.keepOpen = object.keepOpen ?? false;
    message.setDockDetectCameraMode = object.setDockDetectCameraMode ?? false;
    return message;
  },
};

function createBaseG47CommandOverrideResultData(): G47CommandOverrideResultData {
  return {};
}

export const G47CommandOverrideResultData = {
  encode(_: G47CommandOverrideResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): G47CommandOverrideResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseG47CommandOverrideResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): G47CommandOverrideResultData {
    return {};
  },

  toJSON(_: G47CommandOverrideResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<G47CommandOverrideResultData>, I>>(base?: I): G47CommandOverrideResultData {
    return G47CommandOverrideResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<G47CommandOverrideResultData>, I>>(_: I): G47CommandOverrideResultData {
    const message = createBaseG47CommandOverrideResultData();
    return message;
  },
};

function createBaseG47CommandOverrideActionStateData(): G47CommandOverrideActionStateData {
  return {};
}

export const G47CommandOverrideActionStateData = {
  encode(_: G47CommandOverrideActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): G47CommandOverrideActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseG47CommandOverrideActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): G47CommandOverrideActionStateData {
    return {};
  },

  toJSON(_: G47CommandOverrideActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<G47CommandOverrideActionStateData>, I>>(
    base?: I,
  ): G47CommandOverrideActionStateData {
    return G47CommandOverrideActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<G47CommandOverrideActionStateData>, I>>(
    _: I,
  ): G47CommandOverrideActionStateData {
    const message = createBaseG47CommandOverrideActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
